// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2564":"2f2218fc260c384a","4879":"b3d4f0edf9b179fe"}[chunkId] + ".css";
};